import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import st from "@/styles/RefreshButton.module.scss";
import Button from "@/ui/Button.tsx";
import Countdown from "react-countdown";
import useIntervals from "@/hooks/intervals.ts";
import {useAtom} from "jotai";
import useCommon from "@/hooks/common.ts";
import {refresh_interval} from "@/atoms/common.ts";
import LoadIcon from "@/svg/LoadIcon.tsx";

interface RefreshButtonProps {
    outlined?: boolean
    gray?: boolean
    isMobile?: boolean
}

const RefreshButton:React.FC<RefreshButtonProps> = ({outlined, gray, isMobile}) => {
    const {t} = useTranslation()
    const [loading_more, set_loading_more] = useState(false)
    const intervals_hook = useIntervals(refresh_interval, true)
    const [interval, set_interval] = useAtom(refresh_interval)
    const is_interval = Boolean(interval !==  null && interval.length)
    const {getUserUpdate} = useCommon()

    const on_more = () => {
        set_loading_more(true)

        let timeout = setTimeout(() => {
            set_loading_more(false)
            clearTimeout(timeout)
        }, 1000)
    }

    const handleUpdate = ()=> {
        on_more();
        intervals_hook.setIntervalHandler();
        getUserUpdate();
    }

    const renderer = () => {
        return null
    }

    return (
        <Button
            className={clsx(
                st.refresh_btn,
                outlined && st.outlined,
                gray && st.gray,
                isMobile && st.isMobile,
                loading_more && st.loading
            )}
            disabled={is_interval}
            onClick={handleUpdate}
        >
            <LoadIcon />
            <span className={st.label}>{t("refresh_action")}</span>

            {interval !==  null && !!interval.length && (
                <div className={st.countdown}>
                    <Countdown
                        date={JSON.parse(interval).interval}
                        renderer={renderer}
                        intervalDelay={1000}
                        zeroPadTime={2}
                        onComplete={() => {
                            set_interval("")
                        }}
                    />
                </div>
            )}
        </Button>
    )
}

export default RefreshButton